import React  from "react";
import { makeStyles } from "@material-ui/core";
import LogInPopUP from "./LoginPopUp";
import RegisterPopUp from "./RegisterPopUp";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

interface AuthPopUpProps {
  open: boolean;
  isLogIn: boolean;
  handleClose: () => void;
  handleSwitch: () => void;
  openForgot: () => void;
}


const AuthPopUp: React.FC<AuthPopUpProps> = ({
  open,
  isLogIn,
  handleClose,
  handleSwitch,
  openForgot,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LogInPopUP
        open={isLogIn && open}
        handleClose={handleClose}
        handleSwitch={handleSwitch}
        openForgot={openForgot}
      />
      <RegisterPopUp
        open={!isLogIn && open}
        handleClose={handleClose}
        handleSwitch={handleSwitch}
      />
    </div>
  );
};

export default AuthPopUp;
